/*
 * sk-hp-advisor.js — KI-Schädlingsberater der Startseite (Section sk-hp-advisor).
 * 1) Foto-Bestimmung: Bild verkleinern (Canvas, max. 1600 px, JPEG 0.8) → POST {api}/insect/identify
 *    (gleiche API wie /pages/insektenbestimmung) → Ergebnis + passende Produkte (collections/<art>/products.json).
 * 2) KI-Chat: Frage an das Live-Chat-Widget übergeben (window.SKChat aus sk-live-chat.js).
 * Außerdem: jedes [data-sk-chat-open] auf der Seite öffnet den Chat (Fallback: normaler Link).
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var RATE_KEY = 'sk_hpa_uploads';
  var RATE_MAX = 8;
  var RATE_WINDOW = 60 * 60 * 1000;

  function withRoot(path) {
    return (ROOT.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '')) || '/';
  }

  function esc(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(s == null ? '' : String(s)));
    return d.innerHTML;
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) {
      return vars && vars[k] != null ? vars[k] : '';
    });
  }

  function toHandle(str) {
    return String(str || '').toLowerCase()
      .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  /* Nützlinge/geschützte Arten bekommen nie „Mittel gegen …“ (BNatSchG) – Liste wie sections/insect-identifier */
  var NEVER_AGAINST = /hummel|biene|marienkäfer|marienkaefer|schmetterling|falter|libelle|florfliege|schwebfliege|laufkäfer|hirschkäfer|igel|fledermaus|eidechse|frosch|kröte|molch|regenwurm|ohrwurm|spitzmaus|maulwurf|vogel|kehlchen|meise|amsel|specht|rotschwanz|fink|sperling|spatz|zaunkönig|blindschleiche|ringelnatter|schlupfwespe|raubmilbe|nematode/i;
  var MUSHROOM_GENERA = /^(amanita|boletus|cantharellus|agaricus|macrolepiota|russula|lactarius|suillus|coprinus|coprinopsis|coprinellus|pleurotus|armillaria|hypholoma|leccinum|xerocomus|xerocomellus|imleria|morchella|gyromitra|clitocybe|inocybe|cortinarius|galerina|lepiota|tricholoma|hydnum|craterellus|calvatia|lycoperdon|scleroderma|ganoderma|fomes|fomitopsis|trametes|laetiporus|fistulina|sparassis|kuehneromyces|marasmius|mycena|psilocybe|entoloma|paxillus|hygrophorus|lepista|calocybe|clitopilus|stropharia|volvariella|chlorophyllum|phallus|piptoporus|meripilus|auricularia|tremella|helvella|peziza|aleuria|sarcoscypha|hericium|flammulina|pholiota|gymnopilus|hygrocybe|tylopilus|rubroboletus|neoboletus|caloboletus|baorangia|chalciporus|gyroporus|amanitopsis|clathrus|mutinus|geastrum|bovista|pluteus|panaeolus|conocybe|bolbitius|agrocybe|cyathus|schizophyllum|stereum|daedalea|daedaleopsis|bjerkandera|polyporus|cerioporus|lentinus|lentinula|omphalotus|macrocystidia|melanoleuca|infundibulicybe|ampulloclitocybe|leucoagaricus|cystoderma)\b/i;
  function isMushroom(d) {
    var sci = String(d.scientific_name || '');
    if (/^(serpula|coniophora|antrodia|donkioporia|gloeophyllum|fibroporia|meruliporia)\b/i.test(sci)) return false;   // Holzzerstörer = Gebäudeschaden
    if (d.category === 'pilz' || MUSHROOM_GENERA.test(sci)) return true;
    if (d.category !== 'schimmel') return false;
    var txt = (String(d.species_name_de || '') + ' ' + String(d.description || '')).toLowerCase();
    if (/schimmel|aspergillus|penicillium|cladosporium|stachybotrys|alternaria|mucor|rhizopus/.test(txt + ' ' + sci.toLowerCase())) return false;
    return /pilz|hut\b|lamellen|röhren|fruchtkörper|mykorrhiza|stiel|velum/.test(txt);
  }

  /* ---------------- KI-Chat-Übergabe ---------------- */
  function whenChatReady(cb, timeoutMs) {
    if (window.SKChat && typeof window.SKChat.ask === 'function') { cb(window.SKChat); return; }
    var done = false;
    function ready() {
      if (done || !window.SKChat) return;
      done = true;
      cb(window.SKChat);
    }
    document.addEventListener('sk-chat:ready', ready, { once: true });
    // Loader des Widgets reagiert auf Interaktion — zur Sicherheit ein Event auslösen
    try { window.dispatchEvent(new Event('scroll')); } catch (e) {}
    setTimeout(function () {
      if (done) return;
      if (window.SKChat) { ready(); return; }
      done = true;
      cb(null);
    }, timeoutMs || 8000);
  }

  function askChat(text, fallbackHref) {
    whenChatReady(function (chat) {
      if (chat) { chat.ask(text); return; }
      // Fallback: Widget-Bubble klicken, sonst Hilfe-Seite
      var bubble = document.querySelector('.sk-chat__bubble');
      if (bubble) { bubble.click(); return; }
      window.location.href = fallbackHref || withRoot('pages/hilfe');
    });
  }

  function openChat(fallbackHref) {
    whenChatReady(function (chat) {
      if (chat) { chat.open(); return; }
      var bubble = document.querySelector('.sk-chat__bubble');
      if (bubble) { bubble.click(); return; }
      window.location.href = fallbackHref || withRoot('pages/hilfe');
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-sk-chat-open]') : null;
    if (!t) return;
    e.preventDefault();
    openChat(t.getAttribute('href'));
  });

  /* ---------------- Section-Init ---------------- */
  function init(root) {
    if (!root || root.__skInit) return;
    root.__skInit = true;

    var i18n = {};
    try { i18n = JSON.parse(root.querySelector('[data-advisor-i18n]').textContent); } catch (e) {}
    // Der t-Filter liefert HTML-maskierte Texte (z. B. „L&#39;IA“) → dekodieren, esc() maskiert beim Einfügen erneut
    (function () { var ta = document.createElement('textarea'); Object.keys(i18n).forEach(function (k) { ta.innerHTML = i18n[k]; i18n[k] = ta.value; }); })();
    var apiUrl = (root.getAttribute('data-api-url') || '').replace(/\/$/, '');
    var apiKey = root.getAttribute('data-api-key') || '';
    var locale = root.getAttribute('data-locale') || 'de';
    var currency = root.getAttribute('data-currency') || 'EUR';

    /* ---- Chat-Karte ---- */
    var form = root.querySelector('[data-advisor-chat]');
    var qInput = root.querySelector('[data-advisor-q]');
    if (form && qInput) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = qInput.value.trim();
        if (q.length < 2) { qInput.focus(); return; }
        askChat(q, form.getAttribute('action'));
        qInput.value = '';
      });
      root.querySelectorAll('[data-advisor-suggest]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          askChat(btn.textContent.trim(), form.getAttribute('action'));
        });
      });
    }

    /* ---- Foto-Karte ---- */
    var card = root.querySelector('[data-advisor-photo]');
    if (!card) return;
    var fileInput = card.querySelector('[data-advisor-file]');
    var previewImg = card.querySelector('[data-advisor-preview]');
    var consent = card.querySelector('[data-advisor-consent]');
    var submitBtn = card.querySelector('[data-advisor-submit]');
    var statusEl = card.querySelector('[data-advisor-status]');
    var progressEl = card.querySelector('[data-advisor-progress]');
    var resultEl = card.querySelector('[data-advisor-result]');
    var errorEl = card.querySelector('[data-advisor-error]');
    var imageData = null;
    var busy = false;

    function setState(s) {
      card.setAttribute('data-state', s);
    }

    function showError(msg) {
      errorEl.textContent = msg || i18n.error || '';
      setState('error');
    }

    function reset() {
      imageData = null;
      busy = false;
      fileInput.value = '';
      consent.checked = false;
      submitBtn.disabled = true;
      resultEl.innerHTML = '';
      progressEl.style.width = '0';
      setState('idle');
    }

    card.addEventListener('click', function (e) {
      var r = e.target.closest('[data-advisor-reset]');
      if (r) { e.preventDefault(); reset(); fileInput.click(); return; }
      var a = e.target.closest('[data-advisor-ask]');
      if (a) { e.preventDefault(); askChat(a.getAttribute('data-advisor-ask')); }
    });

    function rateOk() {
      try {
        var now = Date.now();
        var ts = JSON.parse(localStorage.getItem(RATE_KEY) || '[]').filter(function (t) { return now - t < RATE_WINDOW; });
        localStorage.setItem(RATE_KEY, JSON.stringify(ts));
        return ts.length < RATE_MAX;
      } catch (e) { return true; }
    }
    function rateRecord() {
      try {
        var ts = JSON.parse(localStorage.getItem(RATE_KEY) || '[]');
        ts.push(Date.now());
        localStorage.setItem(RATE_KEY, JSON.stringify(ts));
      } catch (e) {}
    }

    function resize(file, cb) {
      var reader = new FileReader();
      reader.onerror = function () { cb(null); };
      reader.onload = function (ev) {
        var img = new Image();
        img.onerror = function () { cb(null); };
        img.onload = function () {
          var w = img.naturalWidth, h = img.naturalHeight, max = 1600;
          if (w > max || h > max) {
            var f = Math.min(max / w, max / h);
            w = Math.round(w * f); h = Math.round(h * f);
          }
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          c.getContext('2d').drawImage(img, 0, 0, w, h);
          try { cb(c.toDataURL('image/jpeg', 0.8)); } catch (err) { cb(null); }
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(file);
    }

    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      if (!file) return;
      if (!/^image\//.test(file.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) {
        showError(i18n.error_type);
        return;
      }
      resize(file, function (dataUrl) {
        if (!dataUrl) { showError(i18n.error_type); return; }
        imageData = dataUrl;
        previewImg.src = dataUrl;
        consent.checked = false;
        submitBtn.disabled = true;
        setState('preview');
      });
    });

    consent.addEventListener('change', function () {
      submitBtn.disabled = !consent.checked || busy;
    });

    submitBtn.addEventListener('click', function () {
      if (busy || !imageData || !consent.checked) return;
      if (!apiUrl) { showError(i18n.error); return; }
      if (!rateOk()) { showError(i18n.error_rate); return; }
      busy = true;
      statusEl.textContent = i18n.uploading || '';
      progressEl.style.width = '0';
      setState('loading');

      var xhr = new XMLHttpRequest();
      xhr.open('POST', apiUrl + '/insect/identify');
      xhr.setRequestHeader('Content-Type', 'application/json');
      if (apiKey) xhr.setRequestHeader('x-api-key', apiKey);
      xhr.timeout = 120000;
      xhr.upload.onprogress = function (e) {
        if (e.lengthComputable && e.total > 0) progressEl.style.width = Math.round((e.loaded / e.total) * 100) + '%';
      };
      xhr.upload.onloadend = function () {
        progressEl.style.width = '100%';
        statusEl.textContent = i18n.analyzing || '';
      };
      xhr.onload = function () {
        busy = false;
        var data = null;
        try { data = JSON.parse(xhr.responseText); } catch (e) {}
        if (xhr.status >= 200 && xhr.status < 300 && data) {
          rateRecord();
          renderResult(data);
        } else if (xhr.status === 429) {
          showError(i18n.error_rate);
        } else {
          showError(i18n.error);
        }
      };
      xhr.onerror = function () { busy = false; showError(i18n.error); };
      xhr.ontimeout = function () { busy = false; showError(i18n.error); };
      xhr.send(JSON.stringify({
        image: imageData,
        media_type: 'photo',
        consent_commercial_use: false,
        photo_date: null,
        location: null
      }));
    });

    function relPath(url) {
      try {
        var u = new URL(url, window.location.origin);
        return u.pathname + u.search + u.hash;
      } catch (e) { return url; }
    }

    function money(amount) {
      var n = parseFloat(amount);
      if (!n) return '';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || locale, { style: 'currency', currency: currency }).format(n);
      } catch (e) {
        return n.toFixed(2).replace('.', ',') + ' €';
      }
    }

    function renderResult(data) {
      var html = '';
      var thumb = imageData ? '<img class="sk-hpa__res-thumb" src="' + imageData + '" alt="" width="56" height="56">' : '';
      if (!data.identified) {
        html += '<div class="sk-hpa__res-head">' + thumb + '<div><p class="sk-hpa__res-name">' + esc(i18n.no_match_title) + '</p></div></div>';
        html += '<p class="sk-hpa__hint">' + esc(i18n.no_match_text) + '</p>';
        html += '<div class="sk-hpa__links"><button type="button" class="sk-hpa__btn sk-hpa__btn--ghost" data-advisor-reset>' + esc(i18n.new_photo) + '</button></div>';
        resultEl.innerHTML = html;
        setState('result');
        return;
      }
      var name = data.species_name_de || data.scientific_name || '';
      html += '<div class="sk-hpa__res-head">' + thumb + '<div>';
      html += '<p class="sk-hpa__res-name">' + esc(name) + '</p>';
      if (data.scientific_name && data.scientific_name !== name) html += '<p class="sk-hpa__res-sci">' + esc(data.scientific_name) + '</p>';
      html += '</div></div>';

      html += '<div class="sk-hpa__badges">';
      if (data.confidence != null) {
        var pct = Math.round(data.confidence * 100);
        html += '<span class="sk-hpa__badge">' + esc(fill(i18n.confidence, { pct: pct })) + '</span>';
      }
      if (data.is_pest) html += '<span class="sk-hpa__badge sk-hpa__badge--pest">' + esc(i18n.pest_badge) + '</span>';
      html += '</div>';
      if (data.confidence != null && data.confidence < 0.7) html += '<p class="sk-hpa__hint">' + esc(i18n.low_confidence) + '</p>';
      // Beschreibung kommt von der API auf Deutsch → nur auf DE anzeigen
      if (data.description && /^de/i.test(locale)) html += '<p class="sk-hpa__res-desc">' + esc(data.description) + '</p>';

      html += '<div data-advisor-products></div>';
      html += '<div class="sk-hpa__links">';
      html += '<button type="button" class="sk-hpa__textlink" data-advisor-ask="' + esc(fill(i18n.ask_ai_prefill, { name: name })) + '">' + esc(i18n.ask_ai) + '</button>';
      if (data.glossary_match && data.glossary_match.url) {
        html += '<a class="sk-hpa__textlink" href="' + esc(relPath(data.glossary_match.url)) + '">' + esc(i18n.lexikon) + '</a>';
      }
      html += '<button type="button" class="sk-hpa__textlink" data-advisor-reset>' + esc(i18n.new_photo) + '</button>';
      html += '</div>';
      resultEl.innerHTML = html;
      setState('result');
      loadProducts(data, resultEl.querySelector('[data-advisor-products]'));
      // Für den Merkmals-Schlüssel (sk-id-key, Reiter „Ohne Foto“): Foto-Ergebnis absichern
      try { document.dispatchEvent(new CustomEvent('sk:identify-result', { detail: { identified: true, scientific_name: data.scientific_name || '', name: name, confidence: data.confidence } })); } catch (e) {}
    }

    function productsHtml(list, href, legal) {
      var h = '<p class="sk-hpa__res-products-title">' + esc(i18n.products_title) + '</p><ul class="sk-hpa__products" role="list">';
      list.slice(0, 3).forEach(function (p) {
        var img = p.image || (p.featured_image && (p.featured_image.url || p.featured_image)) || (p.images && p.images[0] && p.images[0].src) || '';
        if (typeof img === 'object') img = img.src || '';
        var price = p.price || (p.variants && p.variants[0] && p.variants[0].price) || '';
        var url = p.url ? relPath(p.url) : withRoot('products/' + p.handle);
        var src = img ? img.split('?')[0] + '?width=240' : '';
        h += '<li><a class="sk-hpa__product" href="' + esc(url.split('?')[0]) + '">';
        if (src) h += '<img src="' + esc(src) + '" alt="" width="120" height="120" loading="lazy">';
        h += '<span class="sk-hpa__product-title">' + esc(p.title) + '</span>';
        if (price) h += '<span class="sk-hpa__product-price">' + esc(money(price)) + '</span>';
        h += '</a></li>';
      });
      h += '</ul>';
      if (href) h += '<a class="sk-hpa__textlink" href="' + esc(href) + '">' + esc(i18n.view_all) + ' →</a>';
      if (legal && legal.trim()) h += '<p class="sk-hpa__legal">' + esc(legal.trim()) + '</p>';
      return h;
    }

    /* Produktvorschläge – gleiche Regeln wie die KI-Bestimmungsseiten (sections/insect-identifier, tryShowCollectionCta):
     * 1) Kollektion aus dem Lexikon-Steckbrief der Art (related_collection), 2) Kollektion nach Art-/Gruppenname,
     * 3) Shop-Suche nur bei Schädlingen und nur Treffer, deren Titel den Namen enthält.
     * Nie Mittel für Pilze, Nützlinge und geschützte Arten (BNatSchG). Ohne passenden Treffer: keine Produkte. */
    function loadCard(data, done) {
      var g = data && data.glossary_match, url = g && g.url ? relPath(g.url).split('?')[0] : '';
      if (url.indexOf('/pages/l/') < 0) { done(null); return; }
      var finished = false;
      var timer = setTimeout(function () { if (!finished) { finished = true; done(null); } }, 4000);
      fetch(url + '?section_id=sk-kt-species-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html && html.match(/<script type="application\/json" data-kt-species-card>([\s\S]*?)<\/script>/), card = null;
          try { card = m ? JSON.parse(m[1]) : null; } catch (e) { card = null; }
          if (!finished) { finished = true; clearTimeout(timer); done(card); }
        })
        .catch(function () { if (!finished) { finished = true; clearTimeout(timer); done(null); } });
    }

    function loadProducts(data, box) {
      if (!box || !data.species_name_de || isMushroom(data)) return;
      var name = String(data.species_name_de);
      if (NEVER_AGAINST.test(name)) return;
      var isMold = data.category === 'schimmel';
      var lastWord = name.split(/[\s-]+/).pop();
      loadCard(data, function (card) {
        if (card && card.beneficial) return;
        var pest = data.is_pest === true;
        var legal = data.category === 'pflanze' ? '' : (i18n.pflicht_biozid || '') + (isMold ? '' : ' ' + (i18n.pflicht_psm || ''));
        var handles = [];
        if (card && card.collection && card.collection.handle) handles.push(card.collection.handle);
        if (isMold) {
          handles.push('schimmel');
        } else if (pest || data.category === 'pflanze') {
          handles.push(toHandle(name));
          if (lastWord && toHandle(lastWord) !== toHandle(name)) handles.push(toHandle(lastWord));
        }
        (function next(i) {
          if (i >= handles.length) {
            if (!pest || !lastWord || lastWord.length < 4) return;
            fetch(withRoot('search/suggest.json') + '?q=' + encodeURIComponent(lastWord) + '&resources[type]=product&resources[limit]=10')
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (j) {
                var ps = j && j.resources && j.resources.results && j.resources.results.products;
                var needle = lastWord.toLowerCase().slice(0, Math.max(4, lastWord.length - 2));
                ps = (ps || []).filter(function (p) { return p.available !== false && String(p.title || '').toLowerCase().indexOf(needle) !== -1; });
                if (ps.length) box.innerHTML = productsHtml(ps, withRoot('search') + '?q=' + encodeURIComponent(lastWord) + '&type=product', legal);
              })
              .catch(function () {});
            return;
          }
          var h = handles[i];
          if (!h) { next(i + 1); return; }
          fetch(withRoot('collections/' + h + '/products.json') + '?limit=6')
            .then(function (r) { if (!r.ok) throw new Error('404'); return r.json(); })
            .then(function (j) {
              var ps = (j.products || []).filter(function (p) {
                return p.variants && p.variants.some(function (v) { return v.available; });
              });
              if (!ps.length) throw new Error('empty');
              box.innerHTML = productsHtml(ps, withRoot('collections/' + h), legal);
            })
            .catch(function () { next(i + 1); });
        })(0);
      });
    }

    reset();
  }

  function boot() {
    document.querySelectorAll('[data-sk-advisor]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
